export default "__VITE_ASSET__IsmzatfM__"